"use client"

import styled from "@emotion/styled"
import { Desktop, Mobile } from "@eurodrive/ui"
import { getNonUmbracoUrl, getUmbracoMediaUrl } from "@eurodrive/utils"
import Image from "next/image"
import ShareButton from "./ShareButton"

const StyledContainer = styled.div`
  width: 100%;
  height: 625px;
  position: relative;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 495px;
  }
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  z-index: 1;
`

const ButtonContainer = styled.div`
  position: fixed;
  top: 88px;
  right: 20px;
  z-index: 2;
  z-index: 1000000;
  ${(props) => props.theme.breakpoints.up("md")} {
    display: none;
  }
`
export default function Hero({
  mainImage,
  desktopImage,
  mobileImage,
}: {
  mainImage: string
  desktopImage?: string
  mobileImage?: string
}) {
  const desktopImg = mainImage || getNonUmbracoUrl(desktopImage) || ""
  const mobileImg = mainImage || getNonUmbracoUrl(mobileImage) || ""
  return (
    <StyledContainer>
      <ButtonContainer>
        <ShareButton />
      </ButtonContainer>
      <Overlay />
      <Desktop>
        <Image
          src={getUmbracoMediaUrl(desktopImg)}
          fill
          sizes="100vw"
          quality={70}
          alt="car"
          style={{ objectFit: "cover" }}
        />
      </Desktop>
      <Mobile>
        <Image
          src={getUmbracoMediaUrl(mobileImg)}
          fill
          sizes="100vw"
          quality={70}
          alt="car"
          style={{ objectFit: "cover" }}
        />
      </Mobile>
    </StyledContainer>
  )
}
